import { useMediaQuery, useTheme } from '@mui/material';
import { DpDrawer } from '@/components/blocks/DpDrawer';
import { DpModal } from '@/components/blocks/DpModal';

export const AdaptiveDialog: React.FC<
	React.PropsWithChildren<{
		onClose: () => void;
		hideCloseButton?: boolean;
		title?: string;
		open?: boolean;
	}>
> = ({ children, onClose, title = '', open = true, hideCloseButton = false }) => {
	const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));

	if (isMobile) {
		return (
			<DpDrawer title={title} open={open} hideCloseButton={hideCloseButton} onClose={onClose}>
				{children}
			</DpDrawer>
		);
	}

	return (
		<DpModal title={title} open={open} hideCloseButton={hideCloseButton} onClose={onClose}>
			{children}
		</DpModal>
	);
};
